<template>
  <div id="home">
    <div
      class="separador text-center py-5"
      data-aos="fade-up"
      data-aos-delay="600"
    >
      <p class=" fXG blanco">Tickets Registrados</p>

      


    </div>

    <div class="container-fluid">
      <!-- <div class="row pb-5">
        <div class="col-12  fG azuloscuro">Semana 1</div>
      </div>-->

      <div class="row">
        <div class="col-6 py-5">
          <router-link class="btn btn-danger pointer" to="/administrador/dashboard"
            >Participaciones &raquo;
          </router-link>
        </div>
        <div class="col-6 py-5 text-right">
          <div class="z100">
            <button class="btnaction px-5 bold z100" @click="logout()">
              Cerrar sesión
            </button>
          </div>
        </div>
      </div>

      <b-tabs content-class="mt-3 row">
        <b-tab title="Usuarios" active>
          <div class>
            <div class="col-12 blanco pt-5 pb-3">
              <span class=" fG">Usuarios</span>
              (Total: {{ users_array.length }})
            </div>
            <div class="col-12">
              <download-excel
                :data="this.users_array"
                :fields="this.excelcolumns"
                name="Kelloteria - Usuarios.xls"
              >
                <button class="btn btn-danger">Exportar Usuarios</button>
              </download-excel>
            </div>
            <div class="col-12 blanco">
              <v-client-table
                :columns="columns_users"
                v-model="users_array"
                :options="options_users"
              ></v-client-table>
            </div>
          </div>
        </b-tab>
        
      </b-tabs>
    </div>

    <Footer></Footer>
    <!-- <Glyphicons></Glyphicons> -->
  </div>
</template>


<script>
const SECONDS_PER_DAY = 86400;
const HOURS_PER_DAY = 24;
const SEMANA_INICIAL = 27;
import Footer from "@/components/Footer";
// import Glyphicons from "@/views/Glyphicons";
import AOS from "aos";
import swal from "sweetalert2";


import * as moment from "moment";

import Vue from "vue";

import { ServerTable, ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

export default {
  components: {
    Footer,
    // Glyphicons,
  },
  data() {
    return {
      columns: [
        "id",
        "week",
        "nombre",
        "apellido",
        "apellido2",
        "email",
        "puntos_convertidos",
        "puntos_acumulados",
        "status",
        "tipo_cupon",
        "codigo_dulceria",
        "codigo_oxxo",
        "tiempo",
        "segundos",
        "intento_trampa",
        // "started_on",
        // "finished_on",
        // "diferencia_segundos_user",
        "created_on_server",
        "finished_on_server",
        "diferencia_segundos_servidor",
      ],
      data: null,
      options: {
        perPage: 100,
        headings: {
          id: "Ticket UID",
          week: "Semana",
          nombre: "Nombre",
          apellido: "Apellido",
          apellido2: "Segundo Apellido",
          email: "Email",
          puntos_convertidos: "Puntos",
          puntos_acumulados: "Puntos agregados por ticket",
          status: "Status Participación",
          tipo_cupon: "Tipo Cupón",
          codigo_dulceria: "Cupón Dulcería",
          codigo_oxxo: "Cupón OXXO",
          tiempo: "Tiempo Participación",
          segundos: "Segundos Participación",
          intento_trampa:
            "Posible Trampa (si fecha, campo válido: Segundos Servidor)",
          // started_on: "Fecha Ini User",
          // finished_on: "Fecha Fin User",
          // diferencia_segs_user: "Segundos User",
          created_on_server: "Fecha Registro (Servidor)",
          finished_on_server: "Fecha Fin de Participación (Servidor)",
          diferencia_segundos_servidor: "Segundos Servidor",
        },
        editableColumns: [],
        sortable: [],
      },
      columns_users: [
        "id",
        "telefono",
        "fecha_registro",
        "tickets_registrados",
      ],
      excelcolumns: {
        "User ID": "id",
        Telefono: "telefono",
        "Fecha de Registro": "fecha_registro",
        "No. Tickets Registrados": "tickets_registrados",
        
      },
      data_users: null,
      options_users: {
        perPage: 100,
        headings: {
          user_id: "UID",
          nombre: "Nombre",
          apellido: "Apellido",
          apellido2: "Segundo Apellido",
          email: "Email",
          genero: "Genero",
          tel: "Tel",
          fecha_nacimiento: "Fec. Nac.",
          edad: "Edad",
          club_cinepolis: "Membresía Club Cinépolis",
          suma_puntos: "Suma Puntos",
          suma_time: "Suma Segundos",
          suma_time_txt: "Tiempo Total",
          num_tickets: "Número de Tickets",
          created_on: "Fecha de Registro",
          dia_registro: "Día de Registro",
        },
        editableColumns: [],
        sortable: ["edad", "suma_puntos", "suma_time", "num_tickets"],
      },
      tickets: [],
      tickets_procesados: [],
      users: {},
      users_array: [],
      users_auth: [],
      mostrar_monto: false,
      monto: 0,
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
    this.init();
  },
  methods: {
    async init() {
      this.$store.dispatch("showLoader", true);
      await this.getUsers();
   
    },
    logout(){
        this.$store.dispatch("logoutReportes");
    },
    seleccionaStatusChange(status) {
      this.monto = 0;
      console.log(status);
      if (
        status == "$40 en productos de la Familia Coca-Cola en tiendas OXXO"
      ) {
        this.mostrar_monto = true;
      } else {
        this.mostrar_monto = false;
      }
    },
    setUsersArray() {
      this.users_array = [];
      Object.keys(this.users).forEach((key) => {
        let obj = this.users[key];
        obj.user_id = key;
        obj.edad = moment().diff(obj.fecha_nacimiento, "years");
        //console.log(key, obj);
        this.users_array.push(obj);
      });
    },
    sumaStatsUser(user_id, puntos, time) {
      if (puntos == undefined) puntos = 0;
      if (time == undefined) time = 0;

      let multiplicador = 1;

      // console.log(user_id);
      // console.log(this.users[user_id]);

      if (this.users[user_id] == undefined) return;

      if (this.users[user_id].suma_puntos == undefined)
        this.users[user_id].suma_puntos = 0;


      

      try {
        this.users[user_id].suma_puntos += parseInt(puntos) * multiplicador;
      } catch (err) {
        console.log(err);
      }

      if (this.users[user_id].suma_time == undefined)
        this.users[user_id].suma_time = 0;
      try {
        this.users[user_id].suma_time += parseInt(time);
        this.users[user_id].suma_time_txt = this.secondsToHms(
          this.users[user_id].suma_time
        );
      } catch (err) {
        console.log(err);
      }

      if (this.users[user_id].num_tickets == undefined)
        this.users[user_id].num_tickets = 0;
      try {
        this.users[user_id].num_tickets++;
      } catch (err) {
        console.log(err);
      }
    },
    calculaDiferenciaTiempos(started, finished) {
      try {
        //console.log({ started: started.seconds });
        //console.log({ finished: finished.seconds });
        if (started.seconds == null || finished.seconds == null) return "error";
        let d1 = moment.unix(started.seconds);
        //console.log({ d1: d1 });
        let d2 = moment.unix(finished.seconds);
        //console.log({ d2: d2 });
        return d2.diff(d1, "seconds");
      } catch (err) {
        return "error";
      }
    },
    async getUsers() {
      console.log("getting users");

      let qData = {
        
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getUsers.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

           
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              console.log('got tickets')
              this.users_array = res.users;
              console.log(this.users_array);
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            console.log(error);
          }
        );
      
    },
    secondsToHms(seconds) {
      const days = Math.floor(seconds / SECONDS_PER_DAY);
      const remainderSeconds = seconds % SECONDS_PER_DAY;
      const hms = new Date(remainderSeconds * 1000)
        .toISOString()
        .substring(11, 19);
      return hms.replace(/^(\d+)/, (h) =>
        `${Number(h) + days * HOURS_PER_DAY}`.padStart(2, "0")
      );
    },
    // procesaTickets(){
    //   this.tickets_procesados = []
    //   this.tickets.forEach(ticket => {

    //   })
    // },
    custom_sort(a, b) {
      return new Date(a.created_on.seconds) - new Date(b.created_on.seconds);
    },
    getNumSemana(fecha) {
      return parseInt(this.getSemana(fecha)) - SEMANA_INICIAL;
    },
    getSemana(fecha) {
      return moment(fecha).add(2, "days").week();
    },
    getFechaFormato(time) {
      return moment.unix(time).format("MMM D, Y HH:mm:ss");
    },
    async changeStatusCreacion(id, userId, value, email) {
      console.log({ changeStatus: id });
      console.log({ changeStatus: value });
      console.log({ changeStatus: email });

      this.$store.dispatch("showLoader", true);

      let puntos_a_sumar = 0;

      var qData = {
        email: email,
      };

      if (value == "1 Combo Cinépolis") {
        //revisar si son 100 o 500 puntos si llevan más de 2 combos registrados en la semana
        puntos_a_sumar = await this.$store.dispatch(
          "revisarSemanaTicketsUsuario",
          {
            id: id,
            userId: userId,
          }
        );

        const https = require("https");

        this.$http
          .post(
            process.env.VUE_APP_API_URL + "envio-dulceria.php",
            JSON.stringify(qData),
            {
              emulateJSON: true,
              httpsAgent: new https.Agent({ rejectUnauthorized: false }),
              headers: {
                "Content-Type": "text/plain",
                //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
              },
            }
          )
          .then(
            async (response) => {
              // get body data

              console.log("envio mail");
              console.log(response);

              let res = response.body;
              if (res.status === "ok") {
                await this.$store.dispatch("actualizarCodigoTicketDulceria", {
                  id: id,
                  userId: userId,
                  codigo: res.cupon,
                  email: email,
                  puntos: puntos_a_sumar,
                  tipo_cupon: value,
                });
                //this.getTickets();
                this.$store.dispatch("showLoader", false);
                //this.$store.dispatch("changeStatusCreacion", { id: id, status: value });
              } else {
                await this.$store.dispatch("actualizarCodigoTicketDulceria", {
                  id: id,
                  userId: userId,
                  codigo: "",
                  email: email,
                  puntos: puntos_a_sumar,
                  tipo_cupon: value,
                });
                swal.fire("Oops", "Se han agotado los cupones.", "warning");
                this.$store.dispatch("showLoader", false);
                //this.getTickets();
              }
            },
            (error) => {
              // error callback
              this.$store.dispatch("showLoader", false);

              console.log("error callback");
              console.log(error);
            }
          );
      } else if (value == "2 o más Combos Cinépolis") {
        puntos_a_sumar = 500;

        const https = require("https");

        this.$http
          .post(
            process.env.VUE_APP_API_URL + "envio-dulceria.php",
            JSON.stringify(qData),
            {
              emulateJSON: true,
              httpsAgent: new https.Agent({ rejectUnauthorized: false }),
              headers: {
                "Content-Type": "text/plain",
                //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
              },
            }
          )
          .then(
            async (response) => {
              // get body data

              console.log("envio mail");
              console.log(response);

              let res = response.body;
              if (res.status === "ok") {
                await this.$store.dispatch("actualizarCodigoTicketDulceria", {
                  id: id,
                  userId: userId,
                  codigo: res.cupon,
                  email: email,
                  puntos: puntos_a_sumar,
                  tipo_cupon: value,
                });
                // this.getTickets();
                this.$store.dispatch("showLoader", false);
                //this.$store.dispatch("changeStatusCreacion", { id: id, status: value });
              } else {
                await this.$store.dispatch("actualizarCodigoTicketDulceria", {
                  id: id,
                  userId: userId,
                  codigo: "",
                  email: email,
                  puntos: puntos_a_sumar,
                  tipo_cupon: value,
                });
                swal.fire("Oops", "Se han agotado los cupones.", "warning");
                // this.getTickets();
                this.$store.dispatch("showLoader", false);
              }
            },
            (error) => {
              // error callback
              this.$store.dispatch("showLoader", false);

              console.log("error callback");
              console.log(error);
            }
          );
      } else if (
        value == "$40 en productos de la Familia Coca-Cola en tiendas OXXO"
      ) {
        if (this.monto == 0) {
          this.$store.dispatch("showLoader", false);
          swal.fire(
            "Oops",
            "Ingresa el monto de productos participantes que contiene el ticket antes de continuar...",
            "warning"
          );
          return;
        }

        puntos_a_sumar = parseInt(Math.floor(this.monto / 40) * 10);

        const https = require("https");

        this.$http
          .post(
            process.env.VUE_APP_API_URL + "envio-oxxo.php",
            JSON.stringify(qData),
            {
              emulateJSON: true,
              httpsAgent: new https.Agent({ rejectUnauthorized: false }),
              headers: {
                "Content-Type": "text/plain",
                //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
              },
            }
          )
          .then(
            async (response) => {
              // get body data

              console.log("envio mail");
              console.log(response);

              let res = response.body;
              if (res.status === "ok") {
                await this.$store.dispatch("changeStatusTicketValidacion", {
                  id: id,
                  userId: userId,
                  codigo: res.cupon,
                  email: email,
                  puntos: puntos_a_sumar,
                  tipo_cupon: value,
                });
                //this.getTickets();
                this.$store.dispatch("showLoader", false);
                this.monto = 0;
                this.mostrar_monto = false;
                //this.$store.dispatch("changeStatusCreacion", { id: id, status: value });
              } else {
                await this.$store.dispatch("changeStatusTicketValidacion", {
                  id: id,
                  userId: userId,
                  codigo: "",
                  email: email,
                  puntos: puntos_a_sumar,
                  tipo_cupon: value,
                });
                swal.fire("Oops", "Se han acabado los cupones.", "warning");
                //this.getTickets();
                this.$store.dispatch("showLoader", false);
                this.monto = 0;
                this.mostrar_monto = false;
              }
            },
            (error) => {
              // error callback
              this.$store.dispatch("showLoader", false);

              console.log("error callback");
              console.log(error);
            }
          );
      } else if (value == "no válido") {
        //
        const https = require("https");

        this.$http
          .post(
            process.env.VUE_APP_API_URL + "envio-no-valido.php",
            JSON.stringify(qData),
            {
              emulateJSON: true,
              httpsAgent: new https.Agent({ rejectUnauthorized: false }),
              headers: {
                "Content-Type": "text/plain",
                //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
              },
            }
          )
          .then(
            async (response) => {
              // get body data
              this.$store.dispatch("showLoader", false);

              console.log("envio mail");
              console.log(response);

              let res = response.body;

              if (res.status == "ok") {
                //swal.fire("Bien", "Correo de notificación enviado.", "success");
                await this.$store.dispatch("actualizarCodigoNoValido", {
                  id: id,
                  userId: userId,
                  email: email,
                  tipo_cupon: value,
                });
                //this.getTickets();
              } else {
                swal.fire("Oops", res.msg, "warning");
              }
            },
            (error) => {
              // error callback
              this.$store.dispatch("showLoader", false);

              console.log("error callback");
              console.log(error);
            }
          );
      }
    },
  },
};
</script>

